class Center {
  constructor(ctx, gameCanvas, difficultyModifier, radius) {
    this.ctx = ctx;
    this.gameCanvas = gameCanvas;
    this.radius = radius;
    if (difficultyModifier == 1) this.color = 'black';
    if (difficultyModifier == 2) this.color = 'black';
    if (difficultyModifier == 3) this.color = 'black';
  }

  render(ctx) {
    let centerX = this.gameCanvas.width / 2;
    let centerY = this.gameCanvas.height / 2;
    ctx.beginPath();
    ctx.arc(centerX, centerY, this.radius, 0, Math.PI * 2, false);
    ctx.fillStyle = this.color;
    ctx.fill();
    ctx.closePath();
  }
}

export default Center;



//////////////////
// WEBPACK FOOTER
// ./lib/center.js
// module id = 82
// module chunks = 0